import { useState } from "react";

import { QuestionIcon, ActiveQuestionIcon } from "../../assets/icons";
import { CloseIcon } from "../../assets/accountIcons";
import { MMSearch } from "../../components/Account/reusables";

const Support = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="size-full min-h-screen min-w-screen">
      <span className="hidden bp:flex p-14 pb-2 lt-2xl-semibold-toggleBG-dark dark:text-white">
        Support
      </span>
      <div className="p-4 bp:px-14 pt-6 col-12 lbp:row-12">
        <div className="col-4 bp:min-w-80">
          <Search />
          <Questions activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
        <ActiveQuestion activeTab={activeTab} />
        <ContactUs />
      </div>
    </div>
  );
};

export default Support;

const Search = () => {
  return (
    <div
      className="relative p-4 rounded-lg col-3"
      style={{
        backgroundImage: `url(/images/search.jpeg)`,
        backgroundPosition: "center top", // Focus on the top-center part of the image
        backgroundSize: "100% 100%", // Stretch the image height to 200% so the top 50% is visible
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="col-4 z-10">
        <div className="flex flex-col">
          <span className="lt-2xl-medium-white">Search for a question</span>
          <span className="satoshi-base-normal-main-dark">
            Type your question or search keyword.
          </span>
        </div>
        <MMSearch value="MM dey here" />
      </div>
    </div>
  );
};

interface Tabs {
  activeTab: number;
  setActiveTab: (tab: number) => void;
}

const Questions = ({ activeTab, setActiveTab }: Tabs) => {
  return (
    <div className="col-2">
      {questions.map((question, index) => {
        const borderColor =
          index === activeTab
            ? "border border-pry-500"
            : "border border-transparent";
        const bgColor = index === activeTab && "bg-pry-25";
        const textColor =
          index === activeTab
            ? "text-pry-600"
            : "text-tabs dark:text-main-dark";
        return (
          <div
            key={index}
            className={`p-1 rounded-md hover:border-border-border1 ${borderColor}`}
          >
            <button
              onClick={() => setActiveTab(index)}
              className={`rounded-[4px] p-2 transition-all duration-300 w-full row-2 justify-between items-center ${bgColor} `}
            >
              <span
                className={`font-lt text-sm font-medium text-start ${textColor}`}
              >
                {question.title}
              </span>
              {activeTab === index ? <ActiveQuestionIcon /> : <QuestionIcon />}
            </button>
          </div>
        );
      })}
      <div className="p-2 grid place-content-center">
        <button className="rounded-lg border border-border-light dark:border-main-light py-2 px-4 bg-BG-light dark:bg-BG-dark satoshi-sm-bold-main-light dark:text-white">
          Load more
        </button>
      </div>
    </div>
  );
};

const ActiveQuestion = ({ activeTab }: { activeTab: number }) => {
  const question = questions[activeTab];
  const time = `Modified on ${question.date} at ${question.time}`;
  return (
    <div className="border border-border-border1 dark:border-main-light dark:bg-BG-dark rounded-lg p-6 col-6 h-fit">
      <div>
        <span className="lt-xl-semibold-pry-900 dark:text-white">
          {question.title}
        </span>
        <p className="satoshi-base-medium-inputBorder">{time}</p>
      </div>
      <p className="satoshi-base-normal-main-light dark:text-main-dark">
        {question.response}
      </p>
    </div>
  );
};

const ContactUs = () => {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="relative bp:min-w-72 rounded-lg px-4 py-5 col-4 bg-BG-light dark:bg-BG-dark h-fit">
      <div className="col-1">
        <span className="inter-sm-semibold-toggleBG-dark dark:text-white">
          Do you still need our help?
        </span>
        <span className="inter-sm-normal-main-light dark:text-main-dark">
          Send your request via email
        </span>
      </div>
      <button className="w-fit rounded-lg px-4 py-2 bg-gradient-to-b from-pry-500 to-pry-600 satoshi-sm-bold-white">
        Contact us
      </button>
      <button className="absolute top-4 right-4" onClick={() => setOpen(false)}>
        <CloseIcon />
      </button>
    </div>
  );
};

const questions = [
  {
    title: "Get started",
    date: "Tue, 31 Aug, 2021",
    time: "10:00 AM",
    response:
      "Kindly check your balance to re-confirm the product has not being received.  Also, give a bit of time as it may be a network delay or system glitch. However, if it doesn't reflect after awhile, kindly send us a mail stating your transaction reference and your email address or phone number. You can also include any other information you think would be relevant in fast tracking the resolution required.",
  },
  {
    title: "Product Not Received After Purchase",
    date: "Tue, 31 Aug, 2021",
    time: "10:00 AM",
    response:
      "Kindly check your balance to re-confirm the product has not being received.  Also, give a bit of time as it may be a network delay or system glitch. However, if it doesn't reflect after awhile, kindly send us a mail stating your transaction reference and your email address or phone number. You can also include any other information you think would be relevant in fast tracking the resolution required.",
  },
  {
    title: "Error Message: You Can Only Buy 5 Items At A Time.",
    date: "Tue, 31 Aug, 2021",
    time: "10:00 AM",
    response:
      "Kindly check your balance to re-confirm the product has not being received.  Also, give a bit of time as it may be a network delay or system glitch. However, if it doesn't reflect after awhile, kindly send us a mail stating your transaction reference and your email address or phone number. You can also include any other information you think would be relevant in fast tracking the resolution required.",
  },
  {
    title: "Error Message: Vending Not Allowed",
    date: "Tue, 31 Aug, 2021",
    time: "10:00 AM",
    response:
      "Kindly check your balance to re-confirm the product has not being received.  Also, give a bit of time as it may be a network delay or system glitch. However, if it doesn't reflect after awhile, kindly send us a mail stating your transaction reference and your email address or phone number. You can also include any other information you think would be relevant in fast tracking the resolution required.",
  },
  {
    title: "Wrong Voucher Purchased.",
    date: "Tue, 31 Aug, 2021",
    time: "10:00 AM",
    response:
      "Kindly check your balance to re-confirm the product has not being received.  Also, give a bit of time as it may be a network delay or system glitch. However, if it doesn't reflect after awhile, kindly send us a mail stating your transaction reference and your email address or phone number. You can also include any other information you think would be relevant in fast tracking the resolution required.",
  },
  {
    title: "How Can I Contact Dataup?",
    date: "Tue, 31 Aug, 2021",
    time: "10:00 AM",
    response:
      "Kindly check your balance to re-confirm the product has not being received.  Also, give a bit of time as it may be a network delay or system glitch. However, if it doesn't reflect after awhile, kindly send us a mail stating your transaction reference and your email address or phone number. You can also include any other information you think would be relevant in fast tracking the resolution required.",
  },
  {
    title: "What Payment Method Is Accepted?",
    date: "Tue, 31 Aug, 2021",
    time: "10:00 AM",
    response:
      "Kindly check your balance to re-confirm the product has not being received.  Also, give a bit of time as it may be a network delay or system glitch. However, if it doesn't reflect after awhile, kindly send us a mail stating your transaction reference and your email address or phone number. You can also include any other information you think would be relevant in fast tracking the resolution required.",
  },
];
